var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"fas fa-eye-slash fa-5x",staticStyle:{"color":"red"}}),_vm._v(" Nothing to see here.. "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Got lost?")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }